var _path, _rect, _rect2, _mask, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossBrowsersGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.313 2.531H11.5c.718 0 1.313.595 1.313 1.313V9.75c0 .738-.595 1.313-1.313 1.313H7.89l.206.656H9.53c.349 0 .656.307.656.656a.66.66 0 0 1-.656.656h-5.25a.648.648 0 0 1-.656-.656.66.66 0 0 1 .656-.656h1.415l.226-.656h-3.61A1.296 1.296 0 0 1 1 9.75V3.844c0-.718.574-1.313 1.313-1.313zM11.5 3.844H2.312v4.594H11.5V3.843z",
    fill: "#808B9A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.35,
    y: 5.194,
    width: 6.05,
    height: 8.675,
    rx: 1.4,
    fill: "#808B9A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.35,
    y: 5.194,
    width: 6.05,
    height: 8.675,
    rx: 1.4,
    stroke: "#fff",
    strokeWidth: 0.8
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "7eynto9ita",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 5.594,
    width: 5.25,
    height: 8,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 5.594,
    width: 5.25,
    height: 8,
    rx: 1,
    fill: "#fff",
    stroke: "#808B9A",
    strokeWidth: 3,
    mask: "url(#7eynto9ita)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBrowsersGrey);
export default __webpack_public_path__ + "static/media/cross_browsers_grey.bb7a7eea792d17a5e72adfd99606f1bc.svg";
export { ForwardRef as ReactComponent };